import { useRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, myFaceAtom, isTextToSpeechAtom } from '../../State';
import { useAppMessage } from '@daily-co/daily-react';
import { useEffect, useRef, useCallback } from 'react';
import './Live2d.css';
import { Vector, Face } from 'kalidokit';
import { Assets } from '@pixi/assets';
export default function Live2dDetectMe({ modelRef, isHairCheck }) {
  const faceValue = useRecoilValue(myFaceAtom);
  const webcamState = useRecoilValue(webcamAtom); //カメラのON/OFF状態
  const isTextToSpeechState = useRecoilValue(isTextToSpeechAtom);
  const sendAppMessage = useAppMessage();
  const intervalRef = useRef(null); //インターバル処理用
  const isSendOK = useRef(true);
  const awayIntervalRef = useRef(null); //顔を検出しなくなってから
  const awayPreviousFaceValue = useRef(null);
  const awayCurrentFaceValue = useRef(null);
  const FPSValue = 40; //75; //100で 10FPS, 50で20FPS

  useEffect(() => {
    const handleEsc = async (event) => {
      //[A]のキーを押した時
      if (event.keyCode === 65) {
        //modelRef.current.internalModel.coreModel.setParameterValueById('hairColor', 1);

        // let hei = modelRef.current.internalModel.coreModel.getCanvasHeight();

        //modelRef.current.internalModel.coreModel.setColor();

        // modelRef.current.internalModel.settings.replaceFiles((file, path) => {
        //   console.log(file);

        //   if (file == 'test.1024/texture_00.png') {
        //     // alert('hi');
        //     return 'test.1024/texture_01.png';
        //   }

        //   return file;
        // });

        let loadURL = '/live2dmodel/test2/test.1024/texture_01.png';
        const texture = await Assets.load(loadURL);
        modelRef.current.internalModel.bindTexture(0, texture);

        // modelRef.current.internalModel.coreModel.update();

        // let gl = canvasRef.current.getContext('webgl');

        // console.log('ここ');
        // console.log(gl);
        //let cubeTexture = gl.createTexture();
        // let cubeImage = new Image();
        // cubeImage.onload = function () {
        //   // handleTextureLoaded(cubeImage, cubeTexture);
        //   modelRef.current.internalModel.bindTexture(0, cubeTexture);
        // };
        // cubeImage.src = '/live2dmodel/test2/test.1024/texture_01.png';

        // console.log('状態');
        // console.log(modelRef.current.internalModel.motionManager.playing);
        // console.log(modelRef.current.internalModel.motionManager.groups);
        // console.log(modelRef.current.internalModel.motionManager.state);

        // var status = await modelRef.current.motion('AnimGroup');
        // var status = await modelRef.current.internalModel.motionManager.startRandomMotion(
        //   'AnimGroup',
        // );

        //console.log(status);

        //modelRef.current.internalModel.motionManager.groups.idle = 'Acting';

        //console.log(modelRef.current.eyeBlink);
        // console.log(modelRef.current.internalModel.eyeBlink);
        //modelRef.current.internalModel.eyeBlink.create();
        // modelRef.current.internalModel.eyeBlink.setParameterIds(['ParamEyeLOpen', 'ParamEyeROpen']);

        //modelRef.current.expression('smile2');
      }

      //[S]のキーを押した時
      if (event.keyCode === 83) {
        //modelRef.current.expression('smile');
        modelRef.current.internalModel.motionManager.groups.idle = 'Idle';

        modelRef.current.internalModel.eyeBlink.setParameterIds([]);
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  //顔認識情報を他のユーザーに送信
  const sendFaceValue = useCallback(
    (newFaceValue) => {
      //WebSocketでメッセージを送信
      sendAppMessage(
        {
          type: 'face',
          face: newFaceValue,
        },
        '*', //自分以外の全員に送る指定
      );
    },
    [faceValue],
  );

  useEffect(() => {
    //アイドルモーションを設定
    setIdleMotion();

    //インターバルをクリア
    clearInter();

    //インターバル開始
    if (intervalRef.current == null) {
      intervalRef.current = setInterval(() => {
        isSendOK.current = true;
      }, FPSValue);
    }

    //インターバル開始
    if (awayIntervalRef.current == null) {
      awayIntervalRef.current = setInterval(() => {
        if (awayPreviousFaceValue.current == null) {
          awayPreviousFaceValue.current = awayCurrentFaceValue.current;
        } else {
          if (
            JSON.stringify(awayPreviousFaceValue.current) ==
            JSON.stringify(awayCurrentFaceValue.current)
          ) {
            // console.log('同じだよ〜');
            // console.log(awayPreviousFaceValue.current);
            // console.log(awayCurrentFaceValue.current);
          }
        }
      }, 2000);
    }

    return () => clearInter();
  }, [webcamState]);

  //各種インターバルのクリア
  function clearInter() {
    //インターバル削除
    if (intervalRef.current != null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (awayIntervalRef.current != null) {
      clearInterval(awayIntervalRef.current);
      awayIntervalRef.current = null;
    }
  }

  //ディフォルトのアイドルモーションを設定
  function setIdleMotion() {
    //モデルがロードされていない場合
    if (modelRef.current == null) {
      //１秒後に再度確認
      setTimeout(() => {
        setIdleMotion();
      }, 1000);

      return;
    }

    //モーションを通常モードに変更
    modelRef.current.internalModel.motionManager.groups.idle = 'Idle';
  }

  useEffect(() => {
    if (modelRef.current == null) return;

    const coreModel = modelRef.current.internalModel.coreModel;

    //自動まばたきを無効にする(設定のjsonの中でEyeBlinkが設定されている場合にご動作するので、ここで無効にしておく)
    modelRef.current.internalModel.eyeBlink = undefined;

    //瞳部分
    // coreModel.setParameterValueById(
    //     "ParamEyeBallX",
    //     lerp(result.pupil.x, coreModel.getParameterValueById("ParamEyeBallX"), lerpAmount)
    // );
    // coreModel.setParameterValueById(
    //     "ParamEyeBallY",
    //     lerp(result.pupil.y, coreModel.getParameterValueById("ParamEyeBallY"), lerpAmount)
    // );

    // X and Y axis rotations are swapped for Live2D parameters
    // because it is a 2D system and KalidoKit is a 3D system

    let lerpAmount = 0.5;

    coreModel.setParameterValueById(
      'ParamAngleX',
      Vector.lerp(faceValue[1], coreModel.getParameterValueById('ParamAngleX'), lerpAmount),
    );
    coreModel.setParameterValueById(
      'ParamAngleY',
      Vector.lerp(faceValue[0], coreModel.getParameterValueById('ParamAngleY'), lerpAmount),
    );
    coreModel.setParameterValueById(
      'ParamAngleZ',
      Vector.lerp(faceValue[2], coreModel.getParameterValueById('ParamAngleZ'), lerpAmount),
    );

    // coreModel.setParameterValueById('ParamAngleX', faceValue[1]);
    // coreModel.setParameterValueById('ParamAngleY', faceValue[0]);
    // coreModel.setParameterValueById('ParamAngleZ', faceValue[2]);

    // coreModel.setParameterValueById('ParamMouthOpenY', faceValue[4] * 1.7);
    // coreModel.setParameterValueById('ParamMouthForm', faceValue[3] * 10);

    //if (isTextToSpeechState == false) {
    coreModel.setParameterValueById(
      'ParamMouthOpenY',
      Vector.lerp(faceValue[4] * 1.7, coreModel.getParameterValueById('ParamMouthOpenY'), 0.2),
    );

    coreModel.setParameterValueById(
      'ParamMouthForm',
      Vector.lerp(faceValue[3] * 10, coreModel.getParameterValueById('ParamMouthForm'), 0.2),
    );
    // }

    //NaNの判定
    if (isNaN(coreModel.getParameterValueById('ParamEyeLOpen'))) {
      coreModel.setParameterValueById('ParamEyeLOpen', faceValue[5]);
      coreModel.setParameterValueById('ParamEyeROpen', faceValue[6]);
    } else {
      let stabilizedEyes = Face.stabilizeBlink(
        {
          l: Vector.lerp(faceValue[5], coreModel.getParameterValueById('ParamEyeLOpen'), 0.7),
          r: Vector.lerp(faceValue[6], coreModel.getParameterValueById('ParamEyeROpen'), 0.7),
        },
        faceValue[7],
      );

      // eye blink
      coreModel.setParameterValueById('ParamEyeLOpen', stabilizedEyes.l);
      coreModel.setParameterValueById('ParamEyeROpen', stabilizedEyes.r);
    }

    // eye blink

    //モーションをアップデート
    //internalModel.motionManager.update(coreModel, Date.now());

    awayCurrentFaceValue.current = faceValue;

    //ヘアチェック画面出ない場合に値を他の相手に送信
    if (isHairCheck == false) {
      //FPS調整用
      if (isSendOK.current) {
        sendFaceValue(faceValue);
        isSendOK.current = false;
      }
    }
  }, [faceValue]);
  return false;
}
